import React from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { RecommendationCaseChip } from "./RecommendationCaseChip";
import { SparklesIcon } from "./SparklesIcon";

function RecommendationCaseCard({ card, onOpenCase }) {
    return (
        <div className="recommendation-case-card" data-testid="recommendation-case-card">
            <RecommendationCaseChip caseType={card.case} />
            <p className="recommendation-case-card__summary">{card.summary}</p>
            <button
                className="recommendation-case-card__button"
                onClick={() => onOpenCase(card.case)}>
                Ver detalle
            </button>
        </div>
    );
}

export function RecommendationsExpanded({ cards, onCollapse, onOpenCase }) {
    return (
        <div className="recommendations-expanded" data-testid="recommendations-expanded">
            <div className="recommendations-expanded__header">
                <span className="recommendations-expanded__title">
                    <SparklesIcon className="recommendations-expanded__title-icon" />
                    Oportunidades detectadas por IA
                </span>
                <button className="recommendations-expanded__collapse" onClick={onCollapse}>
                    Cerrar recomendaciones
                    <KeyboardArrowUpIcon />
                </button>
            </div>

            <div className="recommendations-expanded__cards">
                {cards.map((card) => (
                    <RecommendationCaseCard key={card.case} card={card} onOpenCase={onOpenCase} />
                ))}
            </div>
        </div>
    );
}
